<template>
  <div
    class="referrals-accured-written-off-cell"
    :class="{
      'referrals-accured-written-off-cell-red': cellValue < 0,
      'referrals-accured-written-off-cell-green': cellValue > 0,
      'referrals-accured-written-off-cell-black': cellValue === 0,
    }"
  >
    {{ numberWithSpaces(cellValue) }}
  </div>
</template>

<script>
export default {
  name: "referrals-accured-written-off-cell",
  props: ["cellValue"],
  methods: {
    numberWithSpaces(x) {
      if (x > 0) {
        return `+ ${x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ")}`;
      }
      if (x < 0) {
        return `- ${(-1 * x).toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ")}`;
      }
      return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
    },
  },
};
</script>
<style lang="scss" scoped>
@import "~@/assets/styles/vars";
.referrals-accured-written-off-cell {
  line-height: 13px;
  font-size: 13px;
  padding: 10px !important;
  -webkit-transition: font 0.3s ease;
  text-align: right;
  transition: font 0.3s ease;

  @media screen and (max-width: 700px) {
    text-align: left;
  }

  &-green {
    color: #12c971;
  }

  &-red {
    color: #ff238d;
  }

  &-black {
    color: #000000;
  }
}
</style>
